// removed by extract-text-webpack-plugin
module.exports = {"photoGallery":"styles__photoGallery___3XRcU"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/photoGallery/styles.css
// module id = LROA
// module chunks = 2